// Content data for Sifra Enterprises

export const COMPANY = {
  name: "Sifra Enterprises",
  tagline: "Enterprise IT Hardware & Technology Solutions",
  established: 2011,
  phone: "+91-9818767778",
  phoneRaw: "919818767778",
  emails: ["info@sifraenterprises.com", "sifraenterprises@gmail.com"],
  whatsappUrl: "https://wa.me/919818767778",
  offices: {
    registered:
      "Plot No. 7-F/4, Northern India Complex, Sector-5, 20/3, Mathura Road, Faridabad, Haryana",
    branch: "Basement 230, Sector 10 HBC, Faridabad-121006",
  },
};

export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/ab75a6b4-40aa-4619-828b-47c3585f15f2/images/f039f3dcd19eab428b608635ca4cba1fe581fcc62d3274144905e90e59e29336.png",
  architecture:
    "https://static.prod-images.emergentagent.com/jobs/ab75a6b4-40aa-4619-828b-47c3585f15f2/images/8a6b742038dffe90fe1b7033d0f1934e98fe963ad07ada32833e8eb95abb9311.png",
  server:
    "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  laptop:
    "https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
};

export const VALUES = [
  {
    id: "01",
    title: "Trust & Integrity",
    body: "Genuine branded products, transparent pricing, and honest counsel at every step.",
  },
  {
    id: "02",
    title: "Customer Satisfaction",
    body: "A dedicated account manager for each corporate client — from quote to after-sales.",
  },
  {
    id: "03",
    title: "On-time Delivery",
    body: "Quick turnaround on quotes, procurement, and replacements — across India.",
  },
  {
    id: "04",
    title: "Quality Assurance",
    body: "Only authorised, warrantied hardware from leading global brands.",
  },
  {
    id: "05",
    title: "Long-term Partnership",
    body: "We optimise for relationships, not transactions — standing with clients for years.",
  },
];

export const WHY_SIFRA = [
  { k: "Genuine", v: "Branded products with full manufacturer warranty." },
  { k: "Direct", v: "Competitive pricing through direct sourcing." },
  { k: "Dedicated", v: "One account manager per corporate client." },
  { k: "Quick TAT", v: "Rapid quotes, delivery and on-site support." },
  { k: "Catalogue", v: "Thousands of product options in one place." },
];

export const PRODUCTS = [
  {
    title: "Laptops & Desktops",
    brands: "Dell, HP, Lenovo, Asus, Toshiba",
    note: "Business-grade compute for every workload.",
  },
  {
    title: "Printers & Scanners",
    brands: "HP, Canon, Epson, Brother",
    note: "Office print fleet, MFPs, and document capture.",
  },
  {
    title: "Projectors & Screens",
    brands: "Sony, Epson, BenQ, LG",
    note: "Boardroom, training-room and display solutions.",
  },
  {
    title: "Power & Surge Protectors",
    brands: "APC, Schneider, V-Guard",
    note: "UPS systems, surge protection and power backup.",
  },
  {
    title: "Cables & Connectors",
    brands: "Assorted certified brands",
    note: "HDMI, DP, Cat 6/6a, USB-C, fibre and specialty cabling.",
  },
  {
    title: "External HDDs & Data Recovery",
    brands: "Seagate, WD, Samsung, Kingston",
    note: "Backup storage and enterprise data recovery tooling.",
  },
  {
    title: "Network Products",
    brands: "Cisco, TP-Link, D-Link, Netgear",
    note: "Routers, switches, access points and structured cabling.",
  },
  {
    title: "Notebook Coolers & Accessories",
    brands: "Assorted",
    note: "Coolers, stands, docks and productivity peripherals.",
  },
  {
    title: "CPU / Motherboards / RAM / GPU",
    brands: "Intel, Kingston, Asus",
    note: "Build-to-spec components and system upgrades.",
  },
  {
    title: "Speakers & Headsets",
    brands: "Sony, LG, Samsung",
    note: "Conferencing audio, headsets and boardroom AV.",
  },
];

export const SERVICES = [
  {
    code: "S/01",
    title: "On-Site Computer Support",
    body: "Quick diagnosis and resolution at your office — across Faridabad, Delhi NCR and pan-India partner network.",
    points: ["Issue triage", "Pan-India reach", "SLA-backed visits"],
  },
  {
    code: "S/02",
    title: "Computer Repair & Maintenance",
    body: "Hardware repairs, OS support, component replacement and upgrade planning for your existing IT estate.",
    points: [
      "Hardware & OS",
      "Component swaps",
      "Preventive maintenance",
    ],
  },
  {
    code: "S/03",
    title: "Warranty & After-Sales",
    body: "We handle warranty claims, product replacements and OEM coordination so your teams never stop working.",
    points: ["OEM liaison", "Replacement tracking", "Extended AMC"],
  },
];

export const INDUSTRIES = [
  "IT & ITES",
  "Manufacturing",
  "Healthcare",
  "Educational Institutions",
  "Banking & Financial Services",
  "Retail & E-commerce",
  "Logistics & Supply Chain",
];

// Client entries use real logo images extracted from the company profile PDF.
// Monograms are kept as a graceful fallback if an image fails to load.
export const CLIENTS = [
  { name: "Plasser India",           monogram: "PI", logo: "/clients/plasser-india.png" },
  { name: "ANDRITZ Hydro",           monogram: "AH", logo: "/clients/andritz-hydro.png" },
  { name: "Shangri-La Hotels",       monogram: "SL", logo: "/clients/shangri-la.png" },
  { name: "The Imperial New Delhi",  monogram: "IM", logo: "/clients/the-imperial.png" },
  { name: "YKK",                     monogram: "YK", logo: "/clients/ykk.png" },
  { name: "Suez",                    monogram: "SZ", logo: "/clients/suez.png" },
  { name: "Mahindra Defence",        monogram: "MD", logo: "/clients/mahindra-defence.png" },
  { name: "Romsons",                 monogram: "RM", logo: "/clients/romsons.png" },
  { name: "Velocis",                 monogram: "VL", logo: "/clients/velocis.png" },
  { name: "REW Empowering Machines", monogram: "RE", logo: "/clients/rew.png" },
  { name: "Blue Matter",             monogram: "BM", logo: "/clients/blue-matter.png" },
  { name: "ATOP",                    monogram: "AT", logo: "/clients/atop.png" },
  { name: "DRA Infracon",            monogram: "DR", logo: "/clients/dra-infracon.png" },
  { name: "Bio-Med Healthcare",      monogram: "BH", logo: "/clients/bio-med.png" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact" },
];
